export default __webpack_public_path__ + "static/clothing-v2-05-top-shoulders-c47f6dab793fdb79cc999d90204fda7d.png";